import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TrackJS } from 'trackjs'
import { FeatureTags } from 'src/app/types/feature-tags';
import { environment } from 'src/environments/environment.prod';

@Injectable({
    providedIn: 'root',
})
export class TrackingService {
    featureTags: FeatureTags;
    constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

    private get isTrackJSAvailable(): boolean {
        return isPlatformBrowser(this.platformId) && typeof TrackJS !== 'undefined';
    }

    private get isTrackJSFtagEnabled(): boolean {
        this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
        const isEnabled = this.featureTags && this.featureTags['ftag_enable_track_js']
        return isEnabled
    }

    public initializeTracking(): void {
        if (!this.isTrackJSAvailable) {
            console.warn('TrackJS not loaded');
            return;
        }

        if (!this.isTrackJSFtagEnabled) {
            console.warn('TrackJS disabled via feature flag or not available');
            return;
        }

        const trackjsToken = environment.trackjsToken || ''
        if (trackjsToken) {
            const config = {
                token: trackjsToken,
                enabled: true,
                application: 'storefront',
            }
            TrackJS.install(config);
            console.warn('✅ TrackJS initialized');
        } else {
            console.warn('TrackJS is not initialized: missing token in environment configuration.');
        }

    }

    track(error: Error | Object | String): void {
        const userId = sessionStorage.getItem('userId');
        if (userId) {
            TrackJS.configure({ userId: userId });
        }

        const errorToTrack = (error as any)?.originalError || error;
        TrackJS.track(errorToTrack);
    }

    setTrackingMetadata(): void {
        const storeTheme = sessionStorage.getItem('store-theme')
        const storeId = sessionStorage.getItem('storeId')

        const userId = sessionStorage.getItem('userId');
        if (userId) {
            TrackJS.configure({ userId: userId });
        }

        TrackJS.addMetadata("storeId", storeId);
        TrackJS.addMetadata("storeTheme", storeTheme);
    }

}